<h1 class="form-title form-title__bp_lt-md_center">
  {{ 'register.form.title' | translate }}
</h1>

<form [formGroup]="form" (submit)="onSubmit()" novalidate>
  <app-custom-input-text
    label="register.form.email"
    placeholder="register.form.email"
    key="email"
    type="text"
    [control]="emailControl"
    [submitted]="isSubmitted(emailControl)"
    [errorsList]="errorFeedbackList[registerFormControlName.EMAIL]" />

  <app-custom-select
    label="captive.form.location"
    placeholder="captive.form.location"
    key="country"
    [control]="countryControl"
    [submitted]="isSubmitted(countryControl)"
    [errorsList]="errorFeedbackList[registerFormControlName.COUNTRY]"
    [options]="countries$"
    defaultLabel="select.label.select" />

  <app-custom-input-password
    label="register.form.password"
    placeholder="register.form.password"
    key="password"
    [control]="passwordControl"
    [submitted]="isSubmitted(passwordControl)"
    [errorsList]="errorFeedbackList[registerFormControlName.PASSWORD]" />

  <app-custom-input-password
    label="register.form.confirm-password"
    placeholder="register.form.confirm-password"
    key="repeatPassword"
    [control]="repeatPasswordControl"
    [submitted]="isSubmitted(repeatPasswordControl)"
    [errorsList]="errorFeedbackList[registerFormControlName.REPEAT_PASSWORD]" />

  <div class="form-check">
    <input
      class="form-check-input"
      type="checkbox"
      value=""
      id="term-conditions"
      [formControlName]="registerFormControlName.TERM_CONDITIONS" />

    <label class="form-check-label" for="term-conditions">
      {{ 'register.form.terms-and-conditions1' | translate }}
      <a
        *ngIf="currentLanguage$ | async as currentLanguage"
        (click)="onOpenLink($event, getTermOfUseUrl(currentLanguage?.locale ?? ''))"
        class="link">
        {{ 'register.form.terms-and-conditions' | translate }}
      </a>
      {{ 'register.form.terms-and-conditions2' | translate }}
      <a
        *ngIf="currentLanguage$ | async as currentLanguage"
        (click)="onOpenLink($event, getPrivacyPolicyUrl(currentLanguage?.locale ?? ''))"
        class="link">
        {{ 'register.form.data-policy' | translate }}
      </a>
      {{ 'register.form.terms-and-conditions3' | translate }}
    </label>
  </div>

  <div class="form-check">
    <input
      class="form-check-input"
      type="checkbox"
      value=""
      id="commercial-subscription"
      [formControlName]="registerFormControlName.RECEIVE_PROMOTIONS" />
    <label class="form-check-label" for="commercial-subscription">
      {{ 'register.form.commercial-subscription' | translate }}
    </label>
  </div>

  <app-button
    class="ind-btn-wrapper-100 ind-wrapper--border"
    type="submit"
    label="buttons.labels.create-account"
    [isDisabled]="form && !form.valid" />
</form>

<app-sign-in-mobile-footer />
